import React from "react";
import ButtonComp from "../buttons/buttonComp/buttonComp";


const LoginButton = ({url='#'}) => {
    return (
        <ButtonComp fullWidth={true} backgroundColor={'#FFFFFF'} visible={false} textColor={false} uppercase={true} url={url}>
            <React.Fragment>
                Üye misin? Giriş Yap
            </React.Fragment>
        </ButtonComp>
    );
}

export default LoginButton;
